import { Instagram, Mail } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background border-t border-white/5" data-testid="footer">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold mb-3 gradient-text">Freys Media</h3>
            <p className="text-sm text-muted-foreground">
              Videoproduktion & Creative Direction<br />
              Inhaber: Kenny Frey
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-3">Quick Links</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <a href="#showreel" className="hover:text-[hsl(var(--accent))] transition-colors">
                  Showreel
                </a>
              </li>
              <li>
                <a href="/#" className="hover:text-[hsl(var(--accent))] transition-colors">
                  Cases
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:text-[hsl(var(--accent))] transition-colors">
                  Kontakt
                </a>
              </li>
            </ul>
          </div>

          {/* Social & Contact */}
          <div>
            <h4 className="font-semibold mb-3">Kontakt</h4>
            <div className="space-y-3">
              <a
                href="mailto:kenny@freysmedia.de"
                className="flex items-center gap-2 text-sm text-muted-foreground hover:text-[hsl(var(--accent))] transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-4 h-4" />
                kenny@freysmedia.de
              </a>
              <a
                href="https://instagram.com/kennyfrey_"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-muted-foreground hover:text-[hsl(var(--accent))] transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram className="w-4 h-4" />
                @kennyfrey_
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <p>© {currentYear} Freys Media - gehört Kenny Frey. Alle Rechte vorbehalten.</p>
          <div className="flex gap-6">
            <a href="/impressum" className="hover:text-[hsl(var(--accent))] transition-colors">
              Impressum
            </a>
            <a href="/datenschutz" className="hover:text-[hsl(var(--accent))] transition-colors">
              Datenschutz
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
